export default __webpack_public_path__ + "static/media/gantt.e85150a3.scss";